export default __webpack_public_path__ + "static/media/public.4f60d757.png";